import { Container } from '../../../odie';

import { FullIceBlockProps, IceBlockProps } from '../../defs/block';
import { blockPositionView } from '../../util/blockTools';
import { FitWidthBlockSprite } from './FitWidthBlockSprite';

// constants
//-----------------------------------------------------------------------------
const manifest = {
  image: 'ice/block.ice.full.png',
};

/*
    full ice block view
*/
export class FullIceBlockView extends Container {
  // init
  //-------------------------------------------------------------------------
  constructor(props: FullIceBlockProps | IceBlockProps) {
    // create base view
    super();

    const ice = new FitWidthBlockSprite(manifest.image, props);

    this.addChild(ice);

    // position
    blockPositionView(this, props);
  }

  public static assets(): string[] {
    return [manifest.image];
  }
}
